// extracted by mini-css-extract-plugin
export default {"service-page":"Service_service-page__9oAID","header":"Service_header__9FyU6","header-title":"Service_header-title__N0iuu","header-options":"Service_header-options__D7F22"};